"use client";

import { useRef, useEffect } from "react";

export default function VideoPlayer({ src, poster }: { src: string; poster?: string | null }) {
  const ref = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    const block = (e: Event) => { e.preventDefault(); return false; };
    v.addEventListener("contextmenu", block);
    return () => v.removeEventListener("contextmenu", block);
  }, []);

  return (
    <div className="relative w-full h-full bg-black select-none" onContextMenu={(e) => e.preventDefault()}>
      <video
        ref={ref}
        src={src}
        poster={poster || undefined}
        controls
        controlsList="nodownload noplaybackrate"
        disablePictureInPicture
        playsInline
        className="w-full h-full object-contain"
        onContextMenu={(e) => e.preventDefault()}
      />
    </div>
  );
}
